module.exports = __webpack_public_path__ + "static/img/6545_phase_function_Paper_Points.b8ef75b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6545_phase_function_Paper_Points.png
// module id = jv/T
// module chunks = 0